import React from "react";

export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      <path
        d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z"
        fill="#3758ff"
        opacity="1"
        fillRule="nonzero"
      />
      <path
        d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z"
        fill="#c8d0fe"
        opacity="0.8"
      />
    </g>
  </svg>
);
export const PeopleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"

  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      <path
        d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
        fill="#c8d0fe"
        fillRule="nonzero"
        opacity="0.8"
      />
      <path
        d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export const TeamIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M14.1124454,7.00625159 C14.0755336,7.00212117 14.0380145,7 14,7 L10,7 C9.96198549,7 9.92446641,7.00212117 9.88755465,7.00625159 L7.34761705,4.55799196 C6.95060373,4.17530866 6.9382927,3.54346816 7.32009765,3.14561006 L8.41948359,2 L15.5805164,2 L16.6799023,3.14561006 C17.0617073,3.54346816 17.0493963,4.17530866 16.6523829,4.55799196 L14.1124454,7.00625159 Z"
        fill="#c8d0fe"
      />
      <path
        d="M13.7640285,9 L15.4853424,18.1494183 C15.5450675,18.4668794 15.4477627,18.7936387 15.2240963,19.0267093 L12.7215131,21.6345146 C12.7120098,21.6444174 12.7023037,21.6541236 12.6924008,21.6636269 C12.2939201,22.0460293 11.6608893,22.0329953 11.2784869,21.6345146 L8.77590372,19.0267093 C8.55223728,18.7936387 8.45493249,18.4668794 8.5146576,18.1494183 L10.2359715,9 L13.7640285,9 Z"
        fill="#3758ff"
        opacity="1"
      />
    </g>
  </svg>
);
export const TransactionsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <circle fill="#000000" opacity="0.3" cx="20.5" cy="12.5" r="1.5" />
      <rect
        fill="#c8d0fe"
        opacity="1"
        transform="translate(12.000000, 6.500000) rotate(-15.000000) translate(-12.000000, -6.500000)"
        x="3"
        y="3"
        width="18"
        height="7"
        rx="1"
      />
      <path
        d="M22,9.33681558 C21.5453723,9.12084552 21.0367986,9 20.5,9 C18.5670034,9 17,10.5670034 17,12.5 C17,14.4329966 18.5670034,16 20.5,16 C21.0367986,16 21.5453723,15.8791545 22,15.6631844 L22,18 C22,19.1045695 21.1045695,20 20,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,6 C2,4.8954305 2.8954305,4 4,4 L20,4 C21.1045695,4 22,4.8954305 22,6 L22,9.33681558 Z"
        fill="#3758ff"
      />
    </g>
  </svg>
);
export const FreelancerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      <rect fill="#c8d0fe" opacity="0.3" x="14" y="4.69999981" width="3" height="3" rx="1.5" />
      <path
        d="M6.82775054,15 C6.82139512,14.8644343 6.81818182,14.728047 6.81818182,14.5909091 C6.81818182,9.84628101 10.6644628,6 15.4090909,6 C18.9411859,6 21.9754239,8.13157886 23.2955957,11.1785272 C21.7651986,11.659899 21,12.6003899 21,14 C21,14 21.993332,14 23.979996,14 C23.9932599,14.1952513 24,14.3922931 24,14.5909091 C24,14.728047 23.9967867,14.8644343 23.9904313,15 L24,15 L24,16.5 C24,16.7761424 23.7761424,17 23.5,17 L1,17 C0.44771525,17 5.69110542e-14,16.5522847 5.68434189e-14,16 C5.67757835e-14,15.4477153 0.44771525,15 1,15 L6.82775054,15 Z"
        fill="#3758ff"
      />
    </g>
  </svg>
);
export const TaskIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M7,3 L17,3 C19.209139,3 21,4.790861 21,7 C21,9.209139 19.209139,11 17,11 L7,11 C4.790861,11 3,9.209139 3,7 C3,4.790861 4.790861,3 7,3 Z M7,9 C8.1045695,9 9,8.1045695 9,7 C9,5.8954305 8.1045695,5 7,5 C5.8954305,5 5,5.8954305 5,7 C5,8.1045695 5.8954305,9 7,9 Z"
        fill="#c8d0fe"
      />
      <path
        d="M7,13 L17,13 C19.209139,13 21,14.790861 21,17 C21,19.209139 19.209139,21 17,21 L7,21 C4.790861,21 3,19.209139 3,17 C3,14.790861 4.790861,13 7,13 Z M17,19 C18.1045695,19 19,18.1045695 19,17 C19,15.8954305 18.1045695,15 17,15 C15.8954305,15 15,15.8954305 15,17 C15,18.1045695 15.8954305,19 17,19 Z"
        fill="#3758ff"
        opacity="1"
      />
    </g>
  </svg>
);

export const PaymentsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M3,7 C3,5.34315 4.34315,4 6,4 L18,4 C19.6569,4 21,5.34315 21,7 L21,17 C21,18.6569 19.6569,20 18,20 L6,20 C4.34315,20 3,18.6569 3,17 L3,7 Z"
        fill="#c8d0fe"
      />
      <path
        d="M3,9 L21,9 L21,11 L3,11 L3,9 Z M15,15 C16.1046,15 17,15.8954 17,17 C17,18.1046 16.1046,19 15,19 C13.8954,19 13,18.1046 13,17 C13,15.8954 13.8954,15 15,15 Z"
        fill="#3758ff"
        opacity="1"
      />
    </g>
  </svg>
);


export const EffortSheetIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z"
        fill="#3758ff"
      />
      <rect
        fill="#c8d0fe"
        opacity="1"
        transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519)"
        x="16.3255682"
        y="2.94551858"
        width="3"
        height="18"
        rx="1"
      />
    </g>
  </svg>
);


export const QuickPanelTogglerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <rect fill="#c8d0fe" x="4" y="4" width="7" height="7" rx="1.5" />
      <path
        d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z"
        fill="#3758ff"
        opacity="1"
      />
    </g>
  </svg>
);
export const ArrowIconDown1 = () => (
  <svg
    className={`h-4 w-4`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M14.77 4.21a.75.75 0 01.02 1.06l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 111.08-1.04l3.25 3.75a.75.75 0 001.1 0l3.25-3.75z"
      clipRule="evenodd"
    />
  </svg>
);
export const ArrowIconRight = () => (
  <svg
    className={`h-4 w-4`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5.23 14.77a.75.75 0 010-1.06L9.73 10a.75.75 0 010-1.06L5.23 5.23a.75.75 0 011.06-1.06l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06 0z"
      clipRule="evenodd"
    />
  </svg>
)
export const DotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <circle fill="#c8d0fe" opacity="1" cx="12" cy="12" r="3" />
      <path
        d="M12,17 C10.3431458,17 9,15.6568542 9,14 C9,12.3431458 10.3431458,11 12,11 C13.6568542,11 15,12.3431458 15,14 C15,15.6568542 13.6568542,17 12,17 Z"
        fill="#3758ff"
      />
    </g>
  </svg>
);
export const Dot = ({ className }) => {
  return (
    <svg
      width="6"
      height="6"
      fill="currentColor"
      viewBox="0 0 6 6"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="3" cy="3" r="3" />
    </svg>
  );
}

export const ArrowIconUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="12px"
    height="12px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M4.29289322,14.7071068 L12,7.00000001 L19.7071068,14.7071068 C20.0976311,15.0976311 20.0976311,15.7307977 19.7071068,16.121321 C19.3165825,16.5118453 18.6834175,16.5118453 18.2928932,16.121321 L12,9.82842712 L5.70710678,16.121321 C5.31658249,16.5118453 4.68341751,16.5118453 4.29289322,16.121321 C3.90236891,15.7307977 3.90236891,15.0976311 4.29289322,14.7071068 Z"
        fill="#3758ff"
      />
    </g>
  </svg>
);
export const ArrowIconDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="12px"
    height="12px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M4.29289322,9.29289322 L12,17 L19.7071068,9.29289322 C20.0976311,8.90236893 20.0976311,8.26920233 19.7071068,7.87867902 C19.3165825,7.4881557 18.6834175,7.4881557 18.2928932,7.87867902 L12,14.1715729 L5.70710678,7.87867902 C5.31658249,7.4881557 4.68341751,7.4881557 4.29289322,7.87867902 C3.90236891,8.26920233 3.90236891,8.90236893 4.29289322,9.29289322 Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const ProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zM12 14c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7z"
      fill="#3758ff"
    />
  </svg>
);

export const ProfileTaskIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5 13h14v-2H5v2zm0 4h14v-2H5v2zm0-10v2h14V7H5z"
      fill="#3758ff"
    />
  </svg>
);

export const BellIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-gray-600 sm:h-5 sm:w-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h11z"
    />
  </svg>
);

export const LeadsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect width="24" height="24" fill="none" />
      <path
        d="M12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 Z"
        fill="#c8d0fe"
        fillRule="nonzero"
        opacity="0.8"
      />
      <path
        d="M12,15 C16.418278,15 20,17.2385763 20,21 C20,21.5522847 19.5522847,22 19,22 L5,22 C4.44771525,22 4,21.5522847 4,21 C4,17.2385763 7.581722,15 12,15 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
      <path
        d="M18,8 L16,10 L14,8"
        stroke="#3758ff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const MemoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      <path
        d="M4,4 C4,3.44772 4.44772,3 5,3 L15,3 C15.2652,3 15.5196,3.10536 15.7071,3.29289 L19.7071,7.29289 C19.8946,7.48043 20,7.73478 20,8 L20,19 C20,19.5523 19.5523,20 19,20 L5,20 C4.44772,20 4,19.5523 4,19 L4,4 Z"
        fill="#3758ff"
        opacity="1"
        fillRule="nonzero"
      />
      <path
        d="M8,9 L16,9 L16,11 L8,11 L8,9 Z M8,13 L14,13 L14,15 L8,15 L8,13 Z"
        fill="#c8d0fe"
        opacity="0.8"
      />
    </g>
  </svg>
);
export const MoneyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="32px"
    height="32px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      {/* Main money bag shape */}
      <path
        d="M12,2
           C8,2,6,4,6,8
           L6,16
           C6,17.6569,7.34315,19,9,19
           L15,19
           C16.6569,19,18,17.6569,18,16
           L18,8
           C18,4,16,2,12,2
           Z"
        fill="#3758ff"
        opacity="1"
        fillRule="nonzero"
      />
      {/* Coin detail on the bag */}
      <path
        d="M15,14 m-1,0 
           a1,1 0 1,0 2,0 
           a1,1 0 1,0 -2,0"
        fill="#c8d0fe"
        opacity="0.8"
      />
    </g>
  </svg>
);
export const PendingAmountIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 30 0 30 30 0 30" />
      {/* Money bill shape */}
      <path
        d="M3,7 
           C3,5.9 3.9,5 5,5 
           L19,5 
           C20.1,5 21,5.9 21,7 
           L21,17 
           C21,18.1 20.1,19 19,19 
           L5,19 
           C3.9,19 3,18.1 3,17 
           L3,7 Z"
        fill="#3758ff"
        opacity="1"
        fillRule="nonzero"
      />
      {/* Clock overlay to indicate pending */}
      <path
        d="M18,4
           a3,3 0 1,1 0,6
           a3,3 0 1,1 0,-6
           M17.8,7 L18.2,7 L18.2,5 L17.8,5 Z
           M18,6.8 L19,6.8 L19,7.2 L18,7.2 Z"
        fill="#c8d0fe"
        opacity="0.8"
      />
    </g>
  </svg>
);
export const TotalLeadsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      {/* Two heads */}
      <path
        d="M18,14 C16.3431,14 15,12.6569 15,11 C15,9.34315 16.3431,8 18,8 C19.6569,8 21,9.34315 21,11 C21,12.6569 19.6569,14 18,14 Z 
           M9,11 C6.79086,11 5,9.20914 5,7 C5,4.79086 6.79086,3 9,3 C11.2091,3 13,4.79086 13,7 C13,9.20914 11.2091,11 9,11 Z"
        fill="#c8d0fe"
        fillRule="nonzero"
        opacity="0.8"
      />
      {/* Shoulders & base */}
      <path
        d="M17.6012,15.0006 C21.0077,15.0379 23.7892,16.7601 23.9985,20.4 C24.0069,20.5466 23.9985,21 23.456,21 
           L19.6,21 C19.6,18.7491 18.8563,16.6718 17.6012,15.0006 Z 
           M0.00065,20.1992 C0.38826,15.4265 4.26191,13 8.98334,13 C13.7712,13 17.7049,15.2932 17.9979,20.2 
           C18.0096,20.3955 17.9979,21 17.2467,21 C13.5411,21 8.03472,21 0.7275,21 
           C0.47671,21 -0.02046,20.4592 0.00065,20.1992 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
export const PendingLeadsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />

      {/* Single head */}
      <path
        d="M12,11 C9.79086,11 8,9.20914 8,7 C8,4.79086 9.79086,3 12,3 C14.2091,3 16,4.79086 16,7 C16,9.20914 14.2091,11 12,11 Z"
        fill="#c8d0fe"
        fillRule="nonzero"
        opacity="0.8"
      />

      {/* Shoulders & base */}
      <path
        d="M3,20 C3.388,15.5 7.5,13 12,13 C16.5,13 20.612,15.5 21,20 C21.01,20.2 21,21 20.2,21 C15.9,21 8.1,21 3.8,21 C3.1,21 2.99,20.3 3,20 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />

      {/* Clock overlay */}
      <circle cx="16" cy="6" r="5" fill="#c8d0fe" opacity="0.8" />
      <path
        d="M16,4.5 L16,6.75 L17.5,7.5"
        stroke="#3758ff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const ReachedOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      {/* Two heads */}
      <path
        d="M18,14 C16.3431,14 15,12.6569 15,11 C15,9.34315 16.3431,8 18,8 C19.6569,8 21,9.34315 21,11 C21,12.6569 19.6569,14 18,14 Z 
           M9,11 C6.79086,11 5,9.20914 5,7 C5,4.79086 6.79086,3 9,3 C11.2091,3 13,4.79086 13,7 C13,9.20914 11.2091,11 9,11 Z"
        fill="#c8d0fe"
        fillRule="nonzero"
        opacity="0.8"
      />
      {/* Shoulders & base */}
      <path
        d="M17.6012,15.0006 C21.0077,15.0379 23.7892,16.7601 23.9985,20.4 C24.0069,20.5466 23.9985,21 23.456,21 
           L19.6,21 C19.6,18.7491 18.8563,16.6718 17.6012,15.0006 Z 
           M0.00065,20.1992 C0.38826,15.4265 4.26191,13 8.98334,13 C13.7712,13 17.7049,15.2932 17.9979,20.2 
           C18.0096,20.3955 17.9979,21 17.2467,21 C13.5411,21 8.03472,21 0.7275,21 
           C0.47671,21 -0.02046,20.4592 0.00065,20.1992 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
      {/* Chat bubble overlay on left head */}
      <path
        d="M9,5.5 
           L9,3.5 
           C9,3 9.5,2.5 10,2.5 
           L11.5,2.5 
           C12,2.5 12.5,3 12.5,3.5 
           L12.5,5.5 
           C12.5,6 12,6.5 11.5,6.5 
           L10,6.5 
           C9.5,6.5 9,6 9,5.5 Z 
           M10,6.5 L7.5,8 L7.5,9 L10,7.5 L12.5,9 L12.5,7.5 L10,6.5 Z"
        fill="#c8d0fe"
        opacity="1"
      />
    </g>
  </svg>
);
export const ConfirmedLeadsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      {/* Two heads */}
      <path
        d="M18,14 C16.3431,14 15,12.6569 15,11 C15,9.34315 16.3431,8 18,8 C19.6569,8 21,9.34315 21,11 C21,12.6569 19.6569,14 18,14 Z 
           M9,11 C6.79086,11 5,9.20914 5,7 C5,4.79086 6.79086,3 9,3 C11.2091,3 13,4.79086 13,7 C13,9.20914 11.2091,11 9,11 Z"
        fill="#c8d0fe"
        fillRule="nonzero"
        opacity="0.8"
      />
      {/* Shoulders & base */}
      <path
        d="M17.6012,15.0006 C21.0077,15.0379 23.7892,16.7601 23.9985,20.4 C24.0069,20.5466 23.9985,21 23.456,21 
           L19.6,21 C19.6,18.7491 18.8563,16.6718 17.6012,15.0006 Z 
           M0.00065,20.1992 C0.38826,15.4265 4.26191,13 8.98334,13 C13.7712,13 17.7049,15.2932 17.9979,20.2 
           C18.0096,20.3955 17.9979,21 17.2467,21 C13.5411,21 8.03472,21 0.7275,21 
           C0.47671,21 -0.02046,20.4592 0.00065,20.1992 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
      {/* Check mark overlay on right head */}
      <path
        d="M17,10.5 L18,11.5 L19,10"
        stroke="#c8d0fe"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const TotalCandidatesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle cx="12" cy="7" r="4" fill="#c8d0fe" opacity="0.8" />
      <path
        d="M3,20 C3.5,15.5 7.5,13 12,13 C16.5,13 20.5,15.5 21,20 C21.01,20.2 21,21 20,21 C15.8,21 8.2,21 4,21 C3.1,21 2.99,20.3 3,20 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
export const PendingReviewIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle cx="12" cy="7" r="4" fill="#c8d0fe" opacity="0.8" />
      <path
        d="M3,20 C3.5,15.5 7.5,13 12,13 C16.5,13 20.5,15.5 21,20 C21.01,20.2 21,21 20,21 C15.8,21 8.2,21 4,21 C3.1,21 2.99,20.3 3,20 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
      <circle cx="16" cy="6" r="5" fill="#c8d0fe" opacity="0.8" />
      <path
        d="M16,4.5 L16,6.5 L17.5,7.5"
        stroke="#3758ff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const HiredCandidatesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle cx="12" cy="7" r="7" fill="#c8d0fe" opacity="0.8" />
      <path
        d="M3,20 C3.5,15.5 7.5,13 12,13 C16.5,13 20.5,15.5 21,20 C21.01,20.2 21,21 20,21 C15.8,21 8.2,21 4,21 C3.1,21 2.99,20.3 3,20 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
      <path
        d="M10.5,7.5 L12,9 L15.5,5.5"
        stroke="#3758ff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const TotalJobsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      {/* Light-colored briefcase base */}
      <rect x="4" y="6" width="16" height="12" fill="#c8d0fe" opacity="0.8" />

      {/* Darker handle & top part */}
      <path
        d="M8,6 C8,4 9,3 12,3 C15,3 16,4 16,6 L19,6 C20.1,6 21,6.9 21,8 L21,18 C21,19.1 20.1,20 19,20 L5,20 C3.9,20 3,19.1 3,18 L3,8 C3,6.9 3.9,6 5,6 Z"
        fill="#c8d0fe"
        fillRule="nonzero"
      />

      {/* Handle */}
      <rect x="9" y="4" width="6" height="2" fill="#3758ff" />
    </g>
  </svg>
);
export const OpenPositionsIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.3267 3.86728C10.1647 3.81066 9.97019 3.80008 9.1984 3.80008H8.89745C7.51185 3.80008 6.55033 3.80167 5.8235 3.89614C5.1244 3.98701 4.75685 4.15177 4.49541 4.39614L4.39723 4.49432C4.15286 4.75576 3.9881 5.12331 3.89723 5.82241C3.80276 6.54924 3.80117 7.51077 3.80117 8.89636V17.0001C3.80117 17.4419 3.443 17.8001 3.00117 17.8001C2.55935 17.8001 2.20117 17.4419 2.20117 17.0001L2.20117 8.84041C2.20115 7.52414 2.20113 6.45821 2.31058 5.61618C2.42436 4.74084 2.66837 3.9929 3.2422 3.38703L3.24967 3.37914L3.38023 3.24858L3.38812 3.24111C3.99399 2.66728 4.74193 2.42327 5.61727 2.30949C6.4593 2.20004 7.52523 2.20006 8.8415 2.20008L9.1984 2.20008C9.2357 2.20008 9.27255 2.20005 9.30899 2.20002C9.91463 2.19946 10.4029 2.19901 10.8546 2.35688C11.1286 2.45263 11.386 2.59039 11.6176 2.76522C11.9995 3.05348 12.27 3.46004 12.6055 3.96427C12.6257 3.9946 12.6461 4.02529 12.6668 4.05632C13.0949 4.69849 13.2116 4.8545 13.3486 4.95788C13.4479 5.03281 13.5582 5.09185 13.6756 5.13289C13.8376 5.18951 14.0322 5.20008 14.8039 5.20008L17.0561 5.20008C17.952 5.20005 18.7042 5.20002 19.3023 5.28044C19.9357 5.36559 20.5148 5.55388 20.9811 6.02018C21.4474 6.48649 21.6357 7.0656 21.7208 7.69894C21.8012 8.29709 21.8012 9.0492 21.8012 9.94518V10.5001C21.8012 10.9419 21.443 11.3001 21.0012 11.3001C20.5593 11.3001 20.2012 10.9419 20.2012 10.5001V10.0001C20.2012 9.03466 20.1995 8.39107 20.1351 7.91214C20.0738 7.45622 19.9692 7.27103 19.8497 7.15156C19.7302 7.03208 19.545 6.92747 19.0891 6.86617C18.6102 6.80178 17.9666 6.80008 17.0012 6.80008H14.8039C14.7666 6.80008 14.7298 6.80012 14.6934 6.80015C14.0877 6.80071 13.5994 6.80116 13.1477 6.64329C12.8737 6.54754 12.6163 6.40978 12.3847 6.23495C12.0028 5.94669 11.7323 5.54013 11.3968 5.0359C11.3766 5.00557 11.3562 4.97488 11.3355 4.94384C10.9074 4.30168 10.7907 4.14567 10.6537 4.04229C10.5545 3.96736 10.4441 3.90832 10.3267 3.86728Z" fill="#3755ff" className="my-path"></path>
    <path opacity="0.4" d="M20.6035 12.3014C20.1198 11.6676 19.4228 11.4184 18.6548 11.3068C17.9204 11.2001 16.9699 11.2002 15.8204 11.2002H9.99287C9.30052 11.2002 8.71217 11.2001 8.2324 11.2567C7.72104 11.3169 7.24778 11.4489 6.824 11.771C6.40021 12.0932 6.14633 12.5138 5.95144 12.9904C5.76858 13.4375 5.61114 14.0044 5.42585 14.6715L5.11894 15.7764C4.81007 16.8882 4.55475 17.8073 4.4608 18.5457C4.36257 19.3177 4.41653 20.0581 4.9003 20.6946C5.38407 21.331 6.08298 21.5812 6.85315 21.6932C7.58977 21.8003 8.54364 21.8002 9.69755 21.8002H15.5295C16.2246 21.8002 16.8152 21.8003 17.2966 21.7434C17.8096 21.6828 18.2844 21.55 18.709 21.226C19.1335 20.9019 19.3869 20.479 19.5807 20.0001C19.7625 19.5508 19.9183 18.9812 20.1016 18.3107L20.4039 17.2056C20.7072 16.0968 20.9579 15.18 21.0488 14.4435C21.1437 13.6732 21.0872 12.9352 20.6035 12.3014Z" fill="#3755ff" className="my-path"></path>
  </svg>
);
export const FilledPositionsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="4" y="6" width="16" height="12" fill="#c8d0fe" opacity="0.8" />
      <path
        d="M8,6 C8,4 9,3 12,3 C15,3 16,4 16,6 L19,6 C20.1,6 21,6.9 21,8 L21,18 C21,19.1 20.1,20 19,20 L5,20 C3.9,20 3,19.1 3,18 L3,8 C3,6.9 3.9,6 5,6 Z"
        fill="#3758ff"
        fillRule="nonzero"
      />
      <path
        d="M10,11 L12,13 L15,9"
        stroke="#c8d0fe"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const BuildingIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M11.0551 2.19983H7.94531C7.04933 2.1998 6.29721 2.19977 5.69906 2.28019C5.06572 2.36534 4.48661 2.55362 4.0203 3.01993C3.55399 3.48624 3.36571 4.06535 3.28056 4.69869C3.20014 5.29683 3.20016 6.04894 3.2002 6.94491L3.2002 21.7998H15.8002L15.8002 6.94496C15.8002 6.04897 15.8003 5.29684 15.7198 4.69869C15.6347 4.06535 15.4464 3.48624 14.9801 3.01993C14.5138 2.55362 13.9347 2.36534 13.3013 2.28019C12.7032 2.19977 11.9511 2.1998 11.0551 2.19983Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.2002 7.00007C7.2002 6.55825 7.55837 6.20007 8.0002 6.20007H11.0002C11.442 6.20007 11.8002 6.55825 11.8002 7.00007C11.8002 7.4419 11.442 7.80007 11.0002 7.80007H8.0002C7.55837 7.80007 7.2002 7.4419 7.2002 7.00007Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.2002 11.0001C7.2002 10.5582 7.55837 10.2001 8.0002 10.2001H11.0002C11.442 10.2001 11.8002 10.5582 11.8002 11.0001C11.8002 11.4419 11.442 11.8001 11.0002 11.8001H8.0002C7.55837 11.8001 7.2002 11.4419 7.2002 11.0001Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M9.5002 16.2001C9.94202 16.2001 10.3002 16.5582 10.3002 17.0001L10.3002 20.0001C10.3002 20.4419 9.94202 20.8001 9.5002 20.8001C9.05837 20.8001 8.7002 20.4419 8.7002 20.0001L8.7002 17.0001C8.7002 16.5582 9.05837 16.2001 9.5002 16.2001Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M19.5002 15.2001C19.942 15.2001 20.3002 15.5582 20.3002 16.0001L20.3002 20.0001C20.3002 20.4419 19.942 20.8001 19.5002 20.8001C19.0584 20.8001 18.7002 20.4419 18.7002 20.0001L18.7002 16.0001C18.7002 15.5582 19.0584 15.2001 19.5002 15.2001Z" fill="#3755ff" fillOpacity="0.4" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M2.2002 21.0001C2.2002 20.5582 2.55837 20.2001 3.0002 20.2001L21.0002 20.2001C21.442 20.2001 21.8002 20.5582 21.8002 21.0001C21.8002 21.4419 21.442 21.8001 21.0002 21.8001L3.0002 21.8001C2.55837 21.8001 2.2002 21.4419 2.2002 21.0001Z" fill="#3755ff" className="my-path"></path>
    <path d="M19.5002 9.19995C18.2299 9.19995 17.2002 10.2297 17.2002 11.5V14.5C17.2002 15.7702 18.2299 16.8 19.5002 16.8C20.7705 16.8 21.8002 15.7702 21.8002 14.5V11.5C21.8002 10.2297 20.7705 9.19995 19.5002 9.19995Z" fill="#3755ff" className="my-path"></path>
  </svg>

);
export const BuildingIcon2 = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M12.0551 2.19971H11.9453C11.0493 2.19968 10.2972 2.19965 9.69906 2.28007C9.06572 2.36522 8.48661 2.5535 8.0203 3.01981C7.55399 3.48612 7.36571 4.06523 7.28056 4.69857C7.20014 5.29671 7.20016 6.04882 7.2002 6.94479V17.0546C7.20016 17.9506 7.20014 18.7027 7.28056 19.3009C7.36571 19.9342 7.55399 20.5133 8.0203 20.9796C8.48661 21.4459 9.06572 21.6342 9.69906 21.7194C10.2972 21.7998 11.0493 21.7997 11.9453 21.7997H12.0551C12.9511 21.7997 13.7032 21.7998 14.3013 21.7194C14.9347 21.6342 15.5138 21.4459 15.9801 20.9796C16.4464 20.5133 16.6347 19.9342 16.7198 19.3009C16.8003 18.7027 16.8002 17.9506 16.8002 17.0546V6.94484C16.8002 6.04885 16.8003 5.29672 16.7198 4.69857C16.6347 4.06523 16.4464 3.48612 15.9801 3.01981C15.5138 2.5535 14.9347 2.36522 14.3013 2.28007C13.7032 2.19965 12.9511 2.19968 12.0551 2.19971Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M12.0002 8.19995C12.442 8.19995 12.8002 8.55812 12.8002 8.99995V9.04995C12.8002 9.49178 12.442 9.84995 12.0002 9.84995C11.5584 9.84995 11.2002 9.49178 11.2002 9.04995V8.99995C11.2002 8.55812 11.5584 8.19995 12.0002 8.19995Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M12.0002 12.2C12.442 12.2 12.8002 12.5581 12.8002 13V13.05C12.8002 13.4918 12.442 13.85 12.0002 13.85C11.5584 13.85 11.2002 13.4918 11.2002 13.05V13C11.2002 12.5581 11.5584 12.2 12.0002 12.2Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M6.85189 6.68579C6.52069 6.82315 6.07749 7.08658 5.38281 7.50339L4.38281 8.10339C4.13254 8.25355 3.99386 8.33777 3.89746 8.40914C3.85544 8.44025 3.83528 8.45917 3.82686 8.46804C3.82359 8.47983 3.81773 8.50684 3.81268 8.55889C3.80107 8.67826 3.8002 8.84052 3.8002 9.13238V18C3.8002 18.494 3.8019 18.7841 3.82968 18.9907C3.84083 19.0736 3.85334 19.1178 3.86122 19.139C3.88237 19.1469 3.92664 19.1594 4.00953 19.1705C4.21615 19.1983 4.50618 19.2 5.0002 19.2H6.0002C6.49422 19.2 6.78426 19.1983 6.99088 19.1705C7.07377 19.1594 7.11804 19.1469 7.13918 19.139C7.14707 19.1178 7.15958 19.0736 7.17073 18.9907C7.1985 18.7841 7.2002 18.494 7.2002 18V8.53238C7.2002 7.72225 7.19807 7.20667 7.14545 6.852C7.12646 6.72399 7.10527 6.64935 7.08965 6.6082C7.04633 6.61599 6.97143 6.63621 6.85189 6.68579ZM7.13967 6.60493C7.13967 6.60493 7.13465 6.60558 7.12704 6.60375C7.13627 6.60349 7.13967 6.60493 7.13967 6.60493ZM7.07423 6.57385C7.06875 6.56827 7.06673 6.56362 7.06673 6.56362C7.06673 6.56362 7.06971 6.5658 7.07423 6.57385ZM7.13127 19.1554C7.13127 19.1554 7.13231 19.1526 7.13514 19.1488C7.13281 19.1539 7.13127 19.1554 7.13127 19.1554ZM7.14902 19.1349C7.15278 19.1321 7.15563 19.1311 7.15563 19.1311C7.15563 19.1311 7.15407 19.1326 7.14902 19.1349ZM3.84478 19.1311C3.84478 19.1311 3.84763 19.1321 3.85139 19.1349C3.84633 19.1326 3.84478 19.1311 3.84478 19.1311ZM3.86527 19.1488C3.8681 19.1526 3.86914 19.1554 3.86914 19.1554C3.86914 19.1554 3.8676 19.1539 3.86527 19.1488ZM6.23895 5.20785C6.71135 5.01193 7.30656 4.87115 7.88706 5.19983C8.46757 5.5285 8.65308 6.11132 8.72813 6.6172C8.80031 7.10375 8.80026 7.74056 8.80021 8.47072C8.80021 8.4912 8.8002 8.51175 8.8002 8.53238L8.80021 18.0468C8.80026 18.4778 8.80032 18.8776 8.75646 19.2039C8.70792 19.5649 8.59286 19.9529 8.273 20.2728C7.95313 20.5927 7.5651 20.7077 7.20407 20.7563C6.87785 20.8001 6.47798 20.8001 6.04703 20.8H4.95338C4.52243 20.8001 4.12256 20.8001 3.79633 20.7563C3.43531 20.7077 3.04727 20.5927 2.72741 20.2728C2.40755 19.9529 2.29249 19.5649 2.24395 19.2039C2.20009 18.8776 2.20014 18.4778 2.2002 18.0468L2.2002 9.13238C2.2002 9.1223 2.2002 9.11224 2.2002 9.1022C2.20017 8.85173 2.20014 8.61031 2.22018 8.4041C2.2427 8.17237 2.29462 7.92523 2.43384 7.67933C2.57307 7.43343 2.75828 7.26176 2.9454 7.12322C3.11191 6.99994 3.31894 6.87576 3.53374 6.74692C3.54235 6.74176 3.55098 6.73658 3.55962 6.7314L4.55961 6.1314C4.5773 6.12079 4.59493 6.11021 4.61249 6.09967C5.23857 5.72396 5.7846 5.39628 6.23895 5.20785Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M19.3879 6.09967C19.4055 6.11021 19.4231 6.12079 19.4408 6.1314L20.4408 6.7314C20.4494 6.73658 20.4581 6.74176 20.4667 6.74693C20.6815 6.87577 20.8885 6.99994 21.055 7.12322C21.2421 7.26176 21.4273 7.43343 21.5666 7.67933C21.7058 7.92523 21.7577 8.17237 21.7802 8.4041C21.8003 8.61032 21.8002 8.85173 21.8002 9.10221C21.8002 9.11225 21.8002 9.12231 21.8002 9.13238L21.8002 18.0468C21.8003 18.4778 21.8003 18.8776 21.7565 19.2039C21.7079 19.5649 21.5929 19.9529 21.273 20.2728C20.9531 20.5927 20.5651 20.7077 20.2041 20.7563C19.8778 20.8001 19.478 20.8001 19.047 20.8H17.9534C17.5224 20.8001 17.1226 20.8001 16.7963 20.7563C16.4353 20.7077 16.0473 20.5927 15.7274 20.2728C15.4075 19.9529 15.2925 19.5649 15.2439 19.2039C15.2001 18.8776 15.2001 18.4778 15.2002 18.0468L15.2002 8.53238C15.2002 8.51175 15.2002 8.4912 15.2002 8.47072C15.2001 7.74056 15.2001 7.10375 15.2723 6.6172C15.3473 6.11132 15.5328 5.5285 16.1133 5.19983C16.6939 4.87115 17.2891 5.01193 17.7615 5.20785C18.2158 5.39628 18.7618 5.72396 19.3879 6.09967ZM16.8607 6.60493C16.8607 6.60493 16.8641 6.60349 16.8734 6.60375C16.8658 6.60558 16.8607 6.60493 16.8607 6.60493ZM16.9108 6.6082C16.9541 6.61599 17.029 6.63621 17.1485 6.68579C17.4797 6.82315 17.9229 7.08658 18.6176 7.50339L19.6176 8.10339C19.8679 8.25355 20.0066 8.33777 20.1029 8.40914C20.145 8.44025 20.1651 8.45917 20.1735 8.46804C20.1768 8.47982 20.1827 8.50684 20.1877 8.55889C20.1993 8.67826 20.2002 8.84052 20.2002 9.13238V18C20.2002 18.494 20.1985 18.7841 20.1707 18.9907C20.1596 19.0736 20.1471 19.1178 20.1392 19.139C20.118 19.1469 20.0738 19.1594 19.9909 19.1705C19.7843 19.1983 19.4942 19.2 19.0002 19.2H18.0002C17.5062 19.2 17.2161 19.1983 17.0095 19.1705C16.9266 19.1594 16.8824 19.1469 16.8612 19.139C16.8533 19.1178 16.8408 19.0736 16.8297 18.9907C16.8019 18.7841 16.8002 18.494 16.8002 18V8.53238C16.8002 7.72225 16.8023 7.20667 16.855 6.852C16.8739 6.72399 16.8951 6.64935 16.9108 6.6082ZM16.8448 19.1311C16.8448 19.1311 16.8476 19.1321 16.8514 19.1349C16.8463 19.1326 16.8448 19.1311 16.8448 19.1311ZM16.8653 19.1488C16.8681 19.1526 16.8691 19.1554 16.8691 19.1554C16.8691 19.1554 16.8676 19.1539 16.8653 19.1488ZM20.1313 19.1554C20.1313 19.1554 20.1323 19.1526 20.1351 19.1488C20.1328 19.1539 20.1313 19.1554 20.1313 19.1554ZM20.149 19.1349C20.1528 19.1321 20.1556 19.1311 20.1556 19.1311C20.1556 19.1311 20.1541 19.1326 20.149 19.1349ZM16.9262 6.57385C16.9307 6.5658 16.9337 6.56362 16.9337 6.56362C16.9337 6.56362 16.9317 6.56827 16.9262 6.57385Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.5002 14.2C5.94202 14.2 6.3002 14.5581 6.3002 15L6.3002 17C6.3002 17.4418 5.94202 17.8 5.5002 17.8C5.05837 17.8 4.7002 17.4418 4.7002 17L4.7002 15C4.7002 14.5581 5.05837 14.2 5.5002 14.2Z" fill="#3755ff" fillOpacity="0.4" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M18.5002 14.2C18.942 14.2 19.3002 14.5581 19.3002 15L19.3002 17C19.3002 17.4418 18.942 17.8 18.5002 17.8C18.0584 17.8 17.7002 17.4418 17.7002 17L17.7002 15C17.7002 14.5581 18.0584 14.2 18.5002 14.2Z" fill="#3755ff" fillOpacity="0.4" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.5002 9.19995C5.94202 9.19995 6.3002 9.55812 6.3002 9.99995L6.3002 12C6.3002 12.4418 5.94202 12.8 5.5002 12.8C5.05837 12.8 4.7002 12.4418 4.7002 12L4.7002 9.99995C4.7002 9.55812 5.05837 9.19995 5.5002 9.19995Z" fill="#3755ff" fillOpacity="0.4" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M18.5002 9.19995C18.942 9.19995 19.3002 9.55812 19.3002 9.99995L19.3002 12C19.3002 12.4418 18.942 12.8 18.5002 12.8C18.0584 12.8 17.7002 12.4418 17.7002 12L17.7002 9.99995C17.7002 9.55812 18.0584 9.19995 18.5002 9.19995Z" fill="#3755ff" fillOpacity="0.4" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M12.0002 16.7C12.442 16.7 12.8002 17.0581 12.8002 17.5V20C12.8002 20.4418 12.442 20.8 12.0002 20.8C11.5584 20.8 11.2002 20.4418 11.2002 20V17.5C11.2002 17.0581 11.5584 16.7 12.0002 16.7Z" fill="#3755ff" className="my-path"></path>
  </svg>

);
export const Adminicon = () => (
  <svg width="27px" height="27px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M7.48565 13.2C4.56658 13.2 2.20021 15.5663 2.20021 18.4854V19.7142L2.2002 19.7575C2.20013 19.9803 2.20008 20.156 2.21782 20.3135C2.36408 21.6116 3.38858 22.6361 4.68671 22.7823C4.84417 22.8001 5.01985 22.8 5.24268 22.8L5.28593 22.8H18.7145L18.7577 22.8C18.9806 22.8 19.1563 22.8001 19.3137 22.7823C20.6118 22.6361 21.6363 21.6116 21.7826 20.3135C21.8003 20.156 21.8003 19.9803 21.8002 19.7575L21.8002 19.7142V18.4854C21.8002 15.5663 19.4338 13.2 16.5148 13.2C16.027 13.2 15.5478 13.3393 15.1369 13.5961C13.2326 14.7863 10.7678 14.7863 8.86356 13.5961C8.45264 13.3393 7.97346 13.2 7.48565 13.2Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.9345 1.19995C8.881 1.19995 7.24578 2.91898 7.34832 4.96988L7.52704 8.54427C7.64624 10.9282 9.61388 12.8 12.0008 12.8C14.3878 12.8 16.3554 10.9282 16.4746 8.54427L16.6533 4.96987C16.7559 2.91897 15.1207 1.19995 13.0672 1.19995H10.9345Z" fill="#3755ff" className="my-path"></path>
  </svg>

);

export const ContentGeneratorIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M10.7015 5.02019L8.88944 4.21482C7.67346 3.67434 6.67806 3.23191 5.87304 3.00816C5.04054 2.77676 4.21608 2.72167 3.47542 3.20301C2.73475 3.68435 2.45025 4.46012 2.32359 5.31485C2.20111 6.14136 2.20114 7.23064 2.20117 8.56131V14.6341C2.20115 15.2924 2.20113 15.8528 2.25353 16.3118C2.30942 16.8014 2.43178 17.2556 2.7297 17.6689C3.02762 18.0823 3.41981 18.342 3.86659 18.5498C4.28546 18.7447 4.81715 18.9219 5.44168 19.13L10.5786 20.8424C11.112 21.0207 11.5438 21.1651 12.0012 21.1651C12.4586 21.1651 12.8904 21.0207 13.4238 20.8424L18.5607 19.13C19.1852 18.9219 19.7169 18.7447 20.1358 18.5498C20.5825 18.342 20.9747 18.0823 21.2727 17.6689C21.5706 17.2556 21.6929 16.8014 21.7488 16.3118C21.8012 15.8528 21.8012 15.2924 21.8012 14.6341V8.56129C21.8012 7.23063 21.8012 6.14135 21.6788 5.31485C21.5521 4.46012 21.2676 3.68435 20.5269 3.20301C19.7863 2.72167 18.9618 2.77676 18.1293 3.00816C17.3243 3.23191 16.3289 3.67434 15.1129 4.2148L13.3008 5.02019C12.4363 5.40442 12.2162 5.48463 12.0012 5.48463C11.7861 5.48463 11.566 5.40442 10.7015 5.02019Z" fill="#3755ff" className="my-path"></path>
<path d="M6.28035 7.7245C5.86666 7.56935 5.40553 7.77895 5.25038 8.19264C5.09523 8.60633 5.30482 9.06747 5.71852 9.22261L9.71819 10.7226C10.1319 10.8778 10.593 10.6682 10.7482 10.2545C10.9033 9.84078 10.6937 9.37965 10.28 9.2245L6.28035 7.7245Z" fill="#3755ff" className="my-path"></path>
<path d="M18.3874 9.22261C18.8011 9.06747 19.0107 8.60633 18.8556 8.19264C18.7004 7.77895 18.2393 7.56935 17.8256 7.7245L13.8259 9.2245C13.4122 9.37965 13.2027 9.84078 13.3578 10.2545C13.5129 10.6682 13.9741 10.8778 14.3878 10.7226L18.3874 9.22261Z" fill="#3755ff" className="my-path"></path>
<path d="M5.25038 13.1926C5.40553 12.7789 5.86666 12.5694 6.28035 12.7245L10.28 14.2245C10.6937 14.3796 10.9033 14.8408 10.7482 15.2545C10.593 15.6682 10.1319 15.8778 9.71819 15.7226L5.71852 14.2226C5.30482 14.0675 5.09523 13.6063 5.25038 13.1926Z" fill="#3755ff" className="my-path"></path>
<path d="M18.3874 14.2226C18.8011 14.0675 19.0107 13.6063 18.8556 13.1926C18.7004 12.7789 18.2393 12.5694 17.8256 12.7245L13.8259 14.2245C13.4122 14.3796 13.2027 14.8408 13.3578 15.2545C13.5129 15.6682 13.9741 15.8778 14.3878 15.7226L18.3874 14.2226Z" fill="#3755ff" className="my-path"></path>
</svg>
)
export const CalendarIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M20.9791 4.5203C20.5128 4.05399 19.9337 3.8657 19.3004 3.78055C18.7022 3.70014 17.9501 3.70016 17.0541 3.7002L6.94433 3.70021C6.04834 3.70018 5.29623 3.70016 4.69808 3.78058C4.06474 3.86573 3.48563 4.05401 3.01932 4.52032C2.55301 4.98663 2.36473 5.56574 2.27958 6.19908C2.19916 6.79723 2.19919 7.54935 2.19922 8.44533V17.0551C2.19919 17.9511 2.19916 18.7032 2.27958 19.3014C2.36473 19.9347 2.55301 20.5138 3.01932 20.9801C3.48563 21.4464 4.06474 21.6347 4.69808 21.7199C5.29623 21.8003 6.04834 21.8003 6.94432 21.8002H17.0541C17.9501 21.8003 18.7022 21.8003 19.3004 21.7199C19.9337 21.6347 20.5128 21.4464 20.9791 20.9801C21.4454 20.5138 21.6337 19.9347 21.7189 19.3014C21.7993 18.7032 21.7993 17.9511 21.7992 17.0551V8.4453C21.7993 7.54932 21.7993 6.7972 21.7189 6.19905C21.6337 5.56572 21.4454 4.9866 20.9791 4.5203Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M2.19922 9.19971H21.7992V10.7997H2.19922V9.19971Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.17422 13.9997C7.17422 13.5579 7.53239 13.1997 7.97422 13.1997H8.02422C8.46605 13.1997 8.82422 13.5579 8.82422 13.9997C8.82422 14.4415 8.46605 14.7997 8.02422 14.7997H7.97422C7.53239 14.7997 7.17422 14.4415 7.17422 13.9997Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.17422 16.9997C7.17422 16.5579 7.53239 16.1997 7.97422 16.1997H8.02422C8.46605 16.1997 8.82422 16.5579 8.82422 16.9997C8.82422 17.4415 8.46605 17.7997 8.02422 17.7997H7.97422C7.53239 17.7997 7.17422 17.4415 7.17422 16.9997Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M11.1742 13.9997C11.1742 13.5579 11.5324 13.1997 11.9742 13.1997H12.0242C12.466 13.1997 12.8242 13.5579 12.8242 13.9997C12.8242 14.4415 12.466 14.7997 12.0242 14.7997H11.9742C11.5324 14.7997 11.1742 14.4415 11.1742 13.9997Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M11.1742 16.9997C11.1742 16.5579 11.5324 16.1997 11.9742 16.1997H12.0242C12.466 16.1997 12.8242 16.5579 12.8242 16.9997C12.8242 17.4415 12.466 17.7997 12.0242 17.7997H11.9742C11.5324 17.7997 11.1742 17.4415 11.1742 16.9997Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.1742 13.9997C15.1742 13.5579 15.5324 13.1997 15.9742 13.1997H16.0242C16.466 13.1997 16.8242 13.5579 16.8242 13.9997C16.8242 14.4415 16.466 14.7997 16.0242 14.7997H15.9742C15.5324 14.7997 15.1742 14.4415 15.1742 13.9997Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.1742 16.9997C15.1742 16.5579 15.5324 16.1997 15.9742 16.1997H16.0242C16.466 16.1997 16.8242 16.5579 16.8242 16.9997C16.8242 17.4415 16.466 17.7997 16.0242 17.7997H15.9742C15.5324 17.7997 15.1742 17.4415 15.1742 16.9997Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.99922 2.19971C8.44105 2.19971 8.79922 2.55788 8.79922 2.99971V5.99971C8.79922 6.44153 8.44105 6.79971 7.99922 6.79971C7.55739 6.79971 7.19922 6.44153 7.19922 5.99971V2.99971C7.19922 2.55788 7.55739 2.19971 7.99922 2.19971Z" fill="#3755ff" className="my-path"></path>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.9992 2.19971C16.441 2.19971 16.7992 2.55788 16.7992 2.99971V5.99971C16.7992 6.44153 16.441 6.79971 15.9992 6.79971C15.5574 6.79971 15.1992 6.44153 15.1992 5.99971V2.99971C15.1992 2.55788 15.5574 2.19971 15.9992 2.19971Z" fill="#3755ff" className="my-path"></path>
  </svg>

);